import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const ToolbarLoading: React.FC<
  React.PropsWithChildren<unknown>
> = () => (
  <>
    <Skeleton width={200} height={32} />
    <Skeleton width={200} height={32} />
  </>
);
